import React, { useEffect, useState } from "react";
import { nanoid } from "nanoid";
import queryString from "query-string";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { arrLeft, arrRight } from "../../svgs";
import { PaginationWrapper } from "./styled";

const Pagination: React.FC<any> = ({ current, pages }) => {
  let location = useLocation();
  let navigate = useNavigate();
  const parsedSearch = queryString.parse(location.search);

  const [pagLength, setPagLength] = useState(1);
  const [curPage, setCurPage] = useState(0);

  const paginate = (n) => {
    setCurPage(n);
    const number = n + 1;
    if (n === curPage) return console.log("dont paginate");
    if (!parsedSearch.page) {
      navigate(
        `${location.search}${location.search ? "&" : "?"}page=${number}`
      );
    } else {
      parsedSearch.page = number;
      const stringified = queryString.stringify(parsedSearch);
      navigate("?" + stringified);
    }
  };

  useEffect(() => {
    setPagLength(pages);
    setCurPage(current);
  }, [location.search]);

  return (
    <div>
      {pagLength > 1 ? (
        <PaginationWrapper>
          <button
            className="arr"
            disabled={curPage === 0}
            onMouseUp={() => paginate(curPage - 1)}
          >
            {arrLeft()}
          </button>

          {[...Array(pagLength)].map((el, i) => {
            const firstLast = i === 0 || i === pagLength - 1;
            const activeAndNear =
              i === curPage - 1 || i === curPage + 1 || i === curPage;
            const dots = i === curPage - 2 || i === curPage + 2;
            const button = (
              <button
                key={nanoid()}
                onMouseUp={() => paginate(i)}
                className={`number ${i === curPage ? "active" : ""}`}
              >
                {i + 1}
              </button>
            );

            // show numbers
            if (activeAndNear || firstLast) return button;

            // show dots
            if (!firstLast && dots) {
              if (i === 1 || i === pagLength - 2) return button;
              return (
                <div key={nanoid()} className="dots">
                  &middot;&middot;&middot;
                </div>
              );
            }
            return null;
          })}

          <button
            className="arr"
            disabled={curPage === pagLength - 1}
            onMouseUp={() => paginate(curPage + 1)}
          >
            {arrRight()}
          </button>
        </PaginationWrapper>
      ) : null}
    </div>
  );
};
export default Pagination;
